import { Form } from "@quillforms/renderer-core";
import "@quillforms/renderer-core/build-style/style.css";
import "./App.css";
import { useEffect } from 'react';
import { convertFormat, submitLeads } from './utils'; // Adjust the path as needed
import image from './images/scar.webp'; // Ensure you have a relevant image

export const ScarRevisionForm = () => {
  useEffect(() => {
    document.title = 'Top Scar Revision Specialist!'; // Set the desired title
  }, []);

  return (
    <div style={{ width: "100%", height: "100vh" }}>
      
      <Form
        formId="2" // Ensure unique formId
        formObj={{
          blocks: [
            {
              name: "welcome-screen",
              id: "sr001",
              attributes: {
                buttonText: "Start",
                label: "<b>Top Scar Revision Specialist!<b><br>🌟🌟🌟🌟🌟",
                customHTML: `<br><b>Dr. Shikha Bansal</b><br>
                MBBS, MS, MCh.<br>
                Plastic & Reconstructive Surgery
                <h2>Remove and Heal Scars with Precision!</h2>
                Expert Scar Treatment&nbsp;&nbsp; ✅<br>
                Advanced Scar Revision Techniques&nbsp;&nbsp;✅<br>
                Personalized Care&nbsp;&nbsp;✅<br>
                Enhanced Aesthetic Results&nbsp;&nbsp;✅
                `,
                attachment: {
                  type: "image",
                  url: image
                },
                attachmentMaxWidth: "500px"
              }
            },
            {
              "name": "multiple-choice",
              "id": "q_scar_location",
              "attributes": {
                "required": true,
                "label": "Where is the scar located?",
                "choices": [
                  {"label": "Face", "value": "face"},
                  {"label": "Breast", "value": "breast"},
                  {"label": "Abdomen", "value": "abdomen"},
                  {"label": "Arms/Legs", "value": "arms_legs"},
                  {"label": "Back/Chest", "value": "back_chest"},
                  {"label": "Other", "value": "other"}
                ]
              }
            },
            {
              "name": "multiple-choice",
              "id": "q_scar_age",
              "attributes": {
                "required": true,
                "label": "How old is the scar?",
                "choices": [
                  {"label": "Less than 6 months", "value": "less_than_6_months"},
                  {"label": "6 months to 1 year", "value": "6_months_to_1_year"},
                  {"label": "1 to 3 years", "value": "1_3_years"},
                  {"label": "Over 3 years", "value": "over_3_years"}
                ]
              }
            },
            {
              "name": "multiple-choice",
              "id": "q_previous_treatments",
              "attributes": {
                "label": "Have you undergone any previous scar treatments?",
                "choices": [
                  {"label": "Yes", "value": "yes"},
                  {"label": "No", "value": "no"}
                ]
              }
            },
            {
              "name": "multiple-choice",
              "id": "q_treatment_urgency",
              "attributes": {
                "label": "How soon are you looking for scar revision treatment?",
                "choices": [
                  {"label": "As soon as possible", "value": "asap"},
                  {"label": "Within a week", "value": "within_a_week"},
                  {"label": "Within a month", "value": "within_a_month"},
                  {"label": "Within the next 3 months", "value": "within_3_months"},
                  {"label": "Not urgent", "value": "not_urgent"}
                ]
              }
            },
            {
              name: "short-text",
              id: "name",
              attributes: {
                required: true,
                label: "What's your name?"
              }
            },
            {
              name: "number",
              id: "phone",
              attributes: {
                required: true,
                description: "We value your trust and privacy. Your phone number will be securely shared with our doctor for necessary communication only!",
                label: "What's your phone number?"
              }
            },
          ],
          messages: {
            'block.defaultThankYouScreen.label': 'Thanks! We\'ll reach out shortly with next steps.'
          },
          settings: {
            animationDirection: "vertical",
            disableWheelSwiping: false,
            disableNavigationArrows: false,
            disableProgressBar: false,
            showQuestionsNumbers: true
          },
          theme: {
            font: "Roboto",
            questionsColor: "#1c3d5a",
            buttonsBgColor: "#1c3d5a",
            logo: {
              src: ""
            },
            answersColor: "#1c3d5a",
            buttonsFontColor: "#fff",
            buttonsBorderRadius: 25,
            errorsFontColor: "#fff",
            errorsBgColor: "#f00",
            progressBarFillColor: "#1c3d5a",
            progressBarBgColor: "#ccc"
          }
        }}
        onSubmit={(data, { completeForm, setIsSubmitting, setSubmissionErr }) => {
          let convertedData = convertFormat(data);
          convertedData['type'] = 'scar_revision'
          console.log(JSON.stringify(convertedData));
          let mode = window.location.hostname === 'localhost' ? 'dev' : 'prod';
          submitLeads(convertedData, { mode, targets: 'both', successPolicy: 'any', mockSuccess: true })
            .then(() => {
              setIsSubmitting(false);
              completeForm();
              setTimeout(() => {
                window.location.href = 'https://drshikhabansal.com';
              }, 3000);
            })
            .catch((error) => {
              setIsSubmitting(false);
              setSubmissionErr(error.message);
              console.error('Lead submission error details:', error.result || error);
            });
        }}
      />
    </div>
  );
};
